import { Injectable } from '@angular/core';
import {finalize, tap} from 'rxjs/operators';
import { MonoTypeOperatorFunction, Observable } from 'rxjs';
import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpHeaders,
  HttpInterceptor,
  HttpRequest, HttpResponse
} from '@angular/common/http';


import {User} from "@/core/models/user.model";
import {TokenStorageService} from "@/core/services/internal/token-storage.service";
import {GeneralUrlsService} from "@/core/services/http/api-url/general-urls.service";



@Injectable({
  providedIn: 'root'
})
export class HeaderInterceptor implements HttpInterceptor{

  private currentUser!: User | null;

  constructor(private tokenStorageService: TokenStorageService, private endpointUrlsService: GeneralUrlsService) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    this.currentUser = this.tokenStorageService.getUser();

    const requestWithAuth = this.handleAuthorization(req);
    return next.handle(requestWithAuth).pipe(
      this.handleTrackingRequest(req),
    );
  }

  private handleAuthorization(request: HttpRequest<any>): HttpRequest<any> {
    // Skip presigned AWS uploads
    if (
        request.url.includes('amazonaws.com')
    ) {
      return request;
    }

    const token = this.currentUser?.session?.accessToken;
    const isLoggedIn = !!token;

    const path = this.endpointUrlsService.getPath([request.url])[0];
    const isPublic = Object.values(this.endpointUrlsService.publicEndpoints)
        .some(publicUrl => path.startsWith(
            publicUrl.replace(this.endpointUrlsService['apiAuthority'], '')
        )
    );

    if (isLoggedIn || !isPublic) {
      const isFormData = request.body instanceof FormData;
      const isFileUpload = request.body instanceof File || request.body instanceof Blob;

      let headersConfig: any = {
        Authorization: 'Bearer ' + token!,
        TimeOutSeconds: '5000'
      };

      // ONLY set JSON header for normal requests
      if (!isFormData && !isFileUpload) {
        headersConfig['Content-Type'] = 'application/json';
      }

      const headers = new HttpHeaders(headersConfig);

      return request.clone({ headers });
    }

    return request;
  }

  private handleTrackingRequest(request: HttpRequest<any>): MonoTypeOperatorFunction<HttpEvent<any>> {
    const start = performance.now();
    let status: number | 'ERROR' = 0;

    return (source$) => source$.pipe(
      tap({
        next: (event) => {
          if (event instanceof HttpResponse) {
            status = event.status;
          }
        },
        error: (err) => {
          if (err instanceof HttpErrorResponse) {
            status = err.status;
          }
        }
      }),
      finalize(() => {
        const now = new Date();
        const timestamp = now.toLocaleString();
        const duration = Math.round(performance.now() - start);

        const msg = `[${request.method}] ${request.urlWithParams} → ${status} in ${duration}ms | ${timestamp}`;
        // console.log(msg);
      })
    );
  }
}
